import { useEffect } from 'react'
import { toast as showToast } from 'sonner'
import { type Toast } from '#app/utils/toast.server.ts'

export function useToast(toast?: Toast | null) {
	useEffect(() => {
		if (toast) {
			setTimeout(() => {
				// If no title is provided, use description as the message
				// Otherwise use title with description
				if (!toast.title) {
					showToast[toast.type](toast.description, {
						id: toast.id,
					})
				} else {
					showToast[toast.type](toast.title, {
						id: toast.id,
						description: toast.description,
					})
				}
			}, 0)
		}
	}, [toast])
}
